import { useState } from 'react';
import { PhotoIcon, CloudArrowDownIcon, ShareIcon } from '@heroicons/react/24/outline';
import { saveAs } from 'file-saver';
import { handleShareImage } from '../../utils/helpers';


interface InvitationImageSectionProps {
  invitationFileURL?: string;
  eventTitle?: string;
}

const PLACEHOLDER_IMAGE = 'https://placehold.co/600x600?text=Event+Image';

const InvitationImageSection = ({
  invitationFileURL,
  eventTitle
}: InvitationImageSectionProps) => {
  const [imageError, setImageError] = useState(false);

  const imageSrc = imageError || !invitationFileURL ? PLACEHOLDER_IMAGE : invitationFileURL;

  return (
    <div className="bg-white p-6 rounded-xl shadow-sm">
      <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
        <PhotoIcon className="w-6 h-6 text-purple-600" />
        Event Banner
      </h2>
      <img
        src={imageSrc}
        alt={imageError ? "Event Image Placeholder" : "Event Invitation"}
        className="w-full h-96 object-cover rounded-lg bg-gray-100"
        onError={() => setImageError(true)}
      />
      <div className="flex gap-2 mt-4">
        <button
          onClick={() => saveAs(imageSrc, 'event-image.jpg')}
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          <CloudArrowDownIcon className="w-5 h-5" />
          Download
        </button>
        <button
          onClick={() => handleShareImage(imageSrc, eventTitle)}
          className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
        >
          <ShareIcon className="w-5 h-5" />
          Share
        </button>
      </div>
    </div>
  );
};
export default InvitationImageSection